import { sortBy, uniqBy } from 'lodash';
import { eventMomentFactory } from '../../../misc/eventMomentFactory';

export function getDatesFromItems(event, items) {
    const dates = uniqBy(
        items.map((s) => eventMomentFactory(event, s.start_local).startOf('day')),
        (t) => t.valueOf()
    );

    return sortBy(dates, (d) => d.valueOf());
}
